import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Button } from "reactstrap";
import { Modal, ModalDialog } from "react-bootstrap";
import { sendData, getData, defaultHeaders, Crypt } from "../../../services/auth";

import { useSelector } from "react-redux";
import { InputLabelAlert } from "../../../common/layout";
import { uriList } from "../../../helpers/config";
import { width, } from "../../../helpers";
import { Aguarde, } from '../../../helpers/general'
import moment from 'moment'
import DropZone from '../../../common/dropZone'
import { confirmSwal, swalError } from "../../../helpers/swal";
import { getUrlFileSize } from "../../../helpers/general";
import { QRCodeCanvas } from "qrcode.react";
import Draggable from "react-draggable";
import {
    getBlobFromImageElement,
    copyBlobToClipboard,
} from 'copy-image-clipboard'

class DraggableModalDialog extends React.Component {
    render() {
        return (
            <Draggable handle=".modal-header">
                <ModalDialog {...this.props} />
            </Draggable>
        );
    }
}


const UploadDocumentos = (props) => {
    const [data, setData] = useState({})
    const [gravando, setGravando] = useState(false)
    const [tipos, setTipos] = useState(props.tipos)
    const _login = useSelector((state) => state.login);
    const [validated, setValidated] = useState(false)
    const [pessoaid, setPessoaID] = useState(props.pessoaid)
    const [colaboradores, setColaboradores] = useState([])
    const [loaded, setLoaded] = useState(false)
    const [categoria, setCategoria] = useState(props.categoria)
    const [linkQrCode, setLinkQrCode] = useState('')
    const [deleting, setDeleting] = useState(false)

    useEffect(() => {
        console.log("UploadDocumentos.useEffect:", props.data)
        if (props.data) {
            let _data = {
                id: props.data.ID,
                arquivo: props.data.URL_ARQUIVO,
                descricao: props.data.DESCRICAO,
                tipo_documentoid: props.data.TIPO_DOCUMENTOID,
                validade: moment(props.data.VALIDADE).format('YYYY-MM-DD'),
                tamanho: props.data.TAMANHO,
                // validade: props.data.VALIDADE,
                pessoaid: props.data.PESSOAID
            }
            console.log("UploadDocumentos.useEffect(1):", _data)
            setData(_data)
            setPessoaID(props.data.PESSOAID)
            handleTipoDoc(props.data.TIPO_DOCUMENTOID)
        }

        carregarDados()
    }, [])

    useEffect(() => {
        if (loaded)
            handleQrCode()
    }, [categoria, loaded])

    function handleTipoDoc(e) {
        let tipoid = e
        if (e?.target) {
            setData({ ...data, tipo_documentoid: e.target.value })
            tipoid = e.target.value
        }
        let _tipo = tipos?.filter(t => t.ID == tipoid)
        if (_tipo?.length > 0) {
            console.log("handleTipoDoc:", _tipo[0])
            setCategoria(_tipo[0]?.CATEGORIA)
        }
    }

    function handleFile(e) {
        if (e?.target) {
            console.log("Arquivo: ", e.target?.files[0])
            setData({ ...data, arquivo: e.target?.files[0] })
            console.log(e)
        }
        else if (e) {
            console.log("handleFile(Arquivo): ", e)
            let _data = { ...data, arquivo: e.preview, tamanho: e.size, file: e }
            setData(_data)
            console.log("UploadDocumentos.handleFile(Arquivo): ", _data)
        }
    }

    function handleDeleteFile(_callback) {
        function callback(e) {
            if (!e)
                return

            setDeleting(true)
            console.log("UploadDocumentos.handleDeleteFile(Arquivo)")
            sendData({ uri: uriList("documentosDel"), content: { ...data, onlyFile: true } })
                .then((res) => {
                    console.log("Documentos.handleDeleteFile(ok): ", res);
                    setDeleting(false)
                    if (res.status && parseInt(res.status) > 200) {
                        swalError({
                            title: `Erro ao excluir arquivo! \n${res.data || res.message || res.erro}`,
                        });

                        return false
                    }
                    setData({ ...data, arquivo: null, file: null, size: null })
                    if (_callback)
                        _callback()
                })
                .catch(error => {
                    setDeleting(false)
                    console.log(error);
                    swalError({
                        title: `Erro ao excluir arquivo! \n${error.message}`,
                    });
                })

        }

        console.log("UploadDocumentos.handleDeleteFile(1): ", data)
        if (data.ID || data.id)
            confirmSwal({ callback, title: "Confirma a exclusão do arquivo?" });
        else
            callback()
    }

    async function carregarDados() {
        console.log("UploadDocumentos.carregarDados")
        if (!props.empresa)
            await getColaboradores()

        if (!tipos)
            await getTiposDocumento()

        setLoaded(true)
    }

    async function getColaboradores() {
        await sendData({ uri: uriList("buscarColaboradores"), content: {} })
            .then((res) => {
                console.log("UploadDocumentos.getColaboradores: ", res.data);

                if (res.status && parseInt(res.status) > 200) throw new Error();
                setColaboradores(res)

            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Colaboradores.\n" + e.message);
            });
    }

    async function getTiposDocumento() {
        await getData({ uri: uriList("tiposDocumento") })
            .then((res) => {
                if (res.status && parseInt(res.status) > 200) throw new Error();
                setTipos(res)
                console.log("getTiposDocumento(Tipos de Documento): ", res);
                // if (res?.length && !data.tipo_documentoid)
                //     setData({ ...data, tipo_documentoid: res[0].ID })
            })
            .catch((e) => {
                console.log(e);
                alert("Erro ao obter Tipos de Documento.\n" + e.message);
            });
    }

    function validarDados(event) {
        const form = document.getElementById('form-upload-documentos')
        console.log("UploadDocumentos.validarDados(form): ", form)
        setValidated(false)
        const isValid = form.checkValidity()
        if (!isValid) {
            event.preventDefault()
            event.stopPropagation()
        }

        setValidated(true)
        return isValid
    }

    async function handlePost(e, isClose) {
        console.log("UploadDocumentos.handlePost(Dados): ", data)
        if (!validarDados(e))
            return
        setGravando(true)
        // e.preventDefault()
        let _tipo = data.tipo_documentoid || tipos[0]?.ID
        console.log("UploadDocumentos.handlePost(tipo): ", _tipo)

        let formData = new FormData()
        if (data.id)
            formData.append('id', data.id)
        if (data.file)
            formData.append('file', data.file)
        if (data.arquivo)
            formData.append('arquivo', data.arquivo)
        formData.append('descricao', data.descricao)
        formData.append('tipo_documentoid', _tipo);
        formData.append('validade', moment(data.validade).format('DD/MM/YYYY'));
        formData.append('pessoaid', pessoaid);
        formData.append('tamanho', data.tamanho);


        await axios({
            url: uriList("documentosAdd"),
            method: 'POST',
            headers: defaultHeaders(),
            data: formData
        })
            .then(res => {
                setGravando(false)
                console.log("Registro gravado: ", res)
                setData({})
                if (isClose)
                    handleClose()
            })
            .catch(error => {
                setGravando(false)
                setData({})
                console.log("Erro ao gravar registro: ")
                console.log(error)
            })
        setData({})
    }

    function handleClose() {
        if (props.onCloseEv)
            props.onCloseEv()
    }

    function handleChange(e) {
        let target = e.currentTarget;
        let name = target.name;
        let value = target.value?.toUpperCase();
        console.log("UploadDocumentos.handleChange: ", target)
        setData({ ...data, [name]: value });
        // console.log(`handleChange: ${name} = ${value}`);
    }

    const qrcode = (
        <QRCodeCanvas
            id="qrCode-canvas"
            value={linkQrCode}
            size={200}
            bgColor={"#fff"}
            level={"H"}
        />
    );

    const saveQrCodeAsImage = async () => {
        const imageElement = document.getElementById('qrCode-canvas')

        await getBlobFromImageElement(imageElement)
            .then((blob) => {
                var _file = new File([blob], "QrCode.png", { type: "image/png" });
                console.log("saveQrCodeAsImage: ", _file)
                setData({ ...data, file: _file, tamanho: _file?.size });
                return blob
            })
            .then((blob) => {
                console.log('Blob Copied')
                return copyBlobToClipboard(blob)
            })
            .catch((e) => {

                console.log('Error: ', e.message)
            })
    }

    const handleQrCode = () => {
        console.log("UploadDocumentos.handleQrCode(0): ", { data, pessoaid, categoria })
        if (pessoaid && categoria == "QRCODE") {
            // console.log("UploadDocumentos.handleQrCode(1): ", colaboradores)
            let _colaborador = colaboradores.filter(c => c.PESSOAID == pessoaid)
            // console.log("UploadDocumentos.handleQrCode(colaborador): ", _colaborador)
            if (_colaborador && _colaborador.length > 0) {
                let _link = `${window.location.origin}/documentostec/${Crypt(_colaborador[0]?.CNPJ_CPF?.replace(/\D/g, ''))}`
                setLinkQrCode(_link)
                console.log("UploadDocumentos.handleQrCode: ", _link)
            }

            setTimeout(saveQrCodeAsImage, 0)
        }

        // saveQrCodeAsImage()
    }

    return (
        <>
            <Modal
                size={width() == "mobile" ? "sm" : "lg"}
                show={true}
                onHide={handleClose}
                centered
                animation={false}
                backdrop="static"
                dialogAs={DraggableModalDialog}
            >
                <Modal.Header closeButton >
                    <Modal.Title>
                        <span>Cadastro de Documentos</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="maxWidth750">
                    {deleting && <Aguarde legenda={"Aguarde, excluindo documento..."} />}
                    {gravando ? (
                        <div>Gravando registro...</div>
                    ) : (

                        <form className={`form g-2 border p-2 needs-validation ${validated ? ' was-validated ' : ''}`} noValidade
                            id="form-upload-documentos">
                            {!props.empresa &&
                                <div className="row g-1">
                                    <div className="form-group col-md-12">
                                        <label className="m-0 font-90">Colaborador</label>
                                        <select className="form-control"
                                            onChange={(e) => setPessoaID(e.target.value)} required id="select-colaborador">
                                            <option value="" selected={!pessoaid}>Escolha um colaborador...</option>
                                            {colaboradores ? colaboradores.map((item, key) => {
                                                if (item.NOME || item.CATEGORIA)
                                                    return (
                                                        <option key={item.PESSOAID} value={item.PESSOAID} selected={pessoaid == item.PESSOAID}>
                                                            {item.NOME || item.CATEGORIA}</option>
                                                    )
                                            }) : "Carregando..."}
                                        </select>
                                    </div>
                                </div>}
                            <div className='row g-1'>
                                <div className="form-group col-md-4">
                                    <InputLabelAlert
                                        type="text"
                                        label="Descrição"
                                        id="descricao"
                                        cifrao={false}
                                        value={data.descricao}
                                        handle={handleChange}
                                        required
                                        focus={true}
                                    />
                                </div>
                                <div className="form-group col-md-5">
                                    <label className="m-0 font-90">Tipo de Documento</label>
                                    <select className="form-control"
                                        onChange={handleTipoDoc} required>
                                        <option value="" selected={!data.tipo_documentoid}>Escolha um tipo...</option>
                                        {tipos ? tipos.map((item, key) => {
                                            if (item.NOME || item.CATEGORIA)
                                                return (
                                                    <option key={key} value={item.ID}
                                                        selected={data.tipo_documentoid == item.ID}>{item.NOME || item.CATEGORIA}
                                                    </option>
                                                )
                                        }) : "Carregando..."}
                                    </select>
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="m-0 font-90">Validade</label>
                                    <input className="form-control" id="date"
                                        type="date" value={data.validade} onChange={(e) => setData({ ...data, validade: e.target.value })} required />
                                </div>
                            </div>
                            <div className='row g-1' >
                                {loaded && categoria != "QRCODE" &&
                                    <DropZone
                                        className="col-md-6"
                                        arquivo={data.arquivo}
                                        onSave={(e) => handleFile(e)}
                                        onDelete={handleDeleteFile} />
                                }
                                {loaded && categoria == "QRCODE" &&
                                    <div className="col-md-6">
                                        {/* <Qrcode /> */}
                                        <div style={{ margin: "0px" }}>{qrcode}</div>
                                        <button type="button" onClick={handleQrCode} style={{ marginLeft: "0px" }}>
                                            Gerar QRCode
                                        </button>
                                    </div>
                                }
                            </div>
                        </form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {loaded &&
                        <>
                            <Button color="success" onClick={e => { handlePost(e, false) }} >
                                Gravar
                            </Button>
                            <Button color="success" onClick={e => { handlePost(e, true) }} >
                                Gravar e Fechar
                            </Button>
                        </>
                    }
                    <Button color="secondary" onClick={handleClose}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default UploadDocumentos;